import { render, staticRenderFns } from "./NTabItem.vue?vue&type=template&id=cfd6b808&scoped=true"
import script from "./NTabItem.vue?vue&type=script&lang=js"
export * from "./NTabItem.vue?vue&type=script&lang=js"
import style0 from "./NTabItem.vue?vue&type=style&index=0&id=cfd6b808&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd6b808",
  null
  
)

export default component.exports